import {
  Divider_default
} from "./chunk-EO3353TK.js";
import {
  Box_default
} from "./chunk-GDQZHQO7.js";

// packages/ui-lib/src/layout/Stack.tsx
import React2, { Children } from "react";
import cn from "classnames";

// packages/ui-lib/src/layout/Stack.css.ts
var space = { none: "Stack_none__11zyy920", xs: "Stack_xs__11zyy921", small: "Stack_small__11zyy922", medium: "Stack_medium__11zyy923", large: "Stack_large__11zyy924" };

// packages/ui-lib/src/layout/Stack.tsx
var Stack = ({ children, space: space2, dividers }) => /* @__PURE__ */ React2.createElement(Box_default, {
  className: cn(space2 && space[space2])
}, Children.map(children, (child, index) => child != null ? /* @__PURE__ */ React2.createElement(Box_default, {
  boxWidth: "full",
  pt: space2
}, dividers === true && index > 0 ? /* @__PURE__ */ React2.createElement(Box_default, {
  boxWidth: "full",
  pb: space2
}, /* @__PURE__ */ React2.createElement(Divider_default, null)) : null, child) : null));

export {
  Stack
};
//# sourceMappingURL=chunk-GFL755FM.js.map
